export default {
  lead_modal: {
    title: '📩 Fiyat ve durumu öğren',
    subtitle:
      'Fiyat ve durum değişebilir. İletişim bilgilerinizi bırakın — bir danışman güncel bilgileri teyit etsin.',

    name: 'Adınız',
    contact: 'WhatsApp numarası',
    message: 'Mesaj (isteğe bağlı)',

    cancel: 'İptal',
    submit: 'Gönder',
    sending: 'Gönderiliyor…',

    success: 'Talep gönderildi!',
    error_unknown: 'Bilinmeyen hata'
  }
}
